import { CHIP_BASE_CLASS, CHIP_ACTIVE_CLASS, CHIP_INACTIVE_CLASS } from '../../constants/chipStyles';
import { useVariationCatalog } from '../../hooks/useVariationCatalog';

interface VariationFilterProps {
  selectedTypeId: number | undefined;
  onTypeChange: (typeId: number | undefined) => void;
  values: string[];
  onChange: (values: string[]) => void;
}

export function VariationFilter({ selectedTypeId, onTypeChange, values, onChange }: VariationFilterProps) {
  const { types, isEmpty } = useVariationCatalog();

  const selectedType = selectedTypeId !== undefined
    ? types.find((t) => t.id === selectedTypeId) ?? null
    : null;

  const handleTypeSelect = (typeId: number) => {
    onTypeChange(selectedTypeId === typeId ? undefined : typeId);
  };

  const handleValueToggle = (code: string) => {
    if (values.includes(code)) {
      onChange(values.filter((v) => v !== code));
    } else {
      onChange([...values, code]);
    }
  };

  const handleClear = () => {
    onTypeChange(undefined);
  };

  if (isEmpty) return null;

  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-1.5 text-xs font-bold text-text-dark">
          Tamanho
          {values.length > 0 && (
            <span className="bg-chocolate text-white text-[10px] w-4 h-4 rounded-full flex items-center justify-center font-semibold">
              {values.length}
            </span>
          )}
        </div>
        <button
          onClick={handleClear}
          disabled={selectedTypeId === undefined && values.length === 0}
          className="text-xs text-text-light hover:text-chocolate transition-colors disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:text-text-light"
        >
          Limpar
        </button>
      </div>

      <div className="flex flex-wrap gap-1.5 mb-3">
        {types.map((type) => (
          <button
            key={type.id}
            type="button"
            onClick={() => handleTypeSelect(type.id)}
            className={[CHIP_BASE_CLASS, selectedTypeId === type.id ? CHIP_ACTIVE_CLASS : CHIP_INACTIVE_CLASS].join(' ')}
          >
            {type.name}
          </button>
        ))}
      </div>

      {selectedType && (
        <div className="flex flex-wrap gap-1.5">
          {selectedType.options.map((option) => (
            <button
              key={option.id}
              type="button"
              onClick={() => handleValueToggle(option.code)}
              className={[CHIP_BASE_CLASS, values.includes(option.code) ? CHIP_ACTIVE_CLASS : CHIP_INACTIVE_CLASS].join(' ')}
            >
              {option.label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
